module.exports = __webpack_public_path__ + "static/img/green-checked.f294771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/green-checked.png
// module id = e+yD
// module chunks = 0